// extracted by mini-css-extract-plugin
export default {"clientMoney":"ClientMoney_clientMoney__-eHxF","col":"ClientMoney_col__IE7nI","title":"ClientMoney_title__JuovW","text":"ClientMoney_text__4Fvk6"};